module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont/65bcbc899f379216109acd0b6c494618.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/icons/fontawesome/fontawesome-webfont.svg?v=4.0.3
// module id = 447
// module chunks = 0